import { useFeatureFlag } from '@datacamp/exercise-feature-flags';
export const isUserExcluded = _ref => {
  let {
    hasAiCoachContent,
    isLoggedIn,
    userGroupSettings
  } = _ref;
  if (userGroupSettings.type !== 'success') {
    return {
      isExcluded: true
    };
  }
  const {
    isUserB2B,
    isUserFromDatacamp
  } = userGroupSettings.userGroupSettings;
  const isExcludedB2bUser = isUserB2B && !isUserFromDatacamp;
  const isExcluded = !isLoggedIn || !hasAiCoachContent || isExcludedB2bUser;
  return {
    isExcluded
  };
};
export const useIsAiCoachEnabled = props => {
  const {
    isExcluded
  } = isUserExcluded(props);
  const featureFlag = useFeatureFlag(isExcluded ? '' : 'cp--ai-coach').flag;
  if (isExcluded) {
    return false;
  }
  return featureFlag === 'on';
};